// extracted by mini-css-extract-plugin
export default {"ResutlsFor":"ResultsFor_ResutlsFor__EDGmZ","ClearButton":"ResultsFor_ClearButton__pKPkp"};